/** BEGIN: Global Breakpoints and Styles */
export {
  DEFAULT_HEADER_HEIGHT,
  DEFAULT_HEADER_HEIGHT_MOBILE,
  NOT_DESKTOP_MAX_WIDTH,
  SCROLLABLE_ELEMENT_CLASSNAME,
} from '@nerdwallet/global-nav-vars';

export const DEFAULT_MOBILE_BREAKPOINT = 1024;
export const NW_MOBILE_BREAKPOINT = 768;
export const MOBILE_CUTOFF = 750;
export const MOBILE_ONLY_BREAKPOINT = `(max-width: ${MOBILE_CUTOFF}px)`;
export const MOBILE_TINY_BREAKPOINT = 396;

export const HEADER_HEIGHT_CSSVAR_NAME = '--nav-height';
/** END: Global Breakpoints and Styles */

/** BEGIN: Global Registration Modal Exclusions */
export const CLIENT_IDS_TO_SKIP_ENTIRELY: Array<string> = [
  'interstitial-client',
];

export const VERTICALS_TO_SKIP_ENTIRELY: Array<string> = ['Small Business'];
export const VERTICALS_TO_SKIP_ON_DESKTOP: Array<string> = [];
export const VERTICALS_TO_SKIP_ON_MOBILE: Array<string> = [];

export const URLS_TO_SKIP_ENTIRELY: Array<string> = [
  '/a/insurance/best-home-insurance',
  '/a/insurance/best-homeowners-insurance',
  '/a/insurance/car-insurance',
  '/a/insurance/car-insurance-m',
  '/a/insurance/compare-car-insurance-c-1',
  '/a/insurance/life-insurance',
  '/article/insurance/allstate-geico-progressive-state-farm-comparison',
  '/article/insurance/auto-insurance-reviews',
  '/article/insurance/auto/liability-car-insurance',
  '/article/insurance/auto/ways-to-get-cheapest-car-insurance',
  '/article/insurance/best-car-insurance-companies',
  '/article/insurance/best-car-insurance-in-texas',
  '/article/insurance/best-cheap-car-insurance',
  '/article/insurance/bundling-home-and-auto-insurance',
  '/article/insurance/car-for-license-road-test',
  '/article/insurance/car-insurance-d',
  '/article/insurance/car-insurance-d-1-go-c-a',
  '/article/insurance/car-insurance-d-1-go-c-a-sw',
  '/article/insurance/car-insurance-discounts',
  '/article/insurance/car-insurance-dui',
  '/article/insurance/car-insurance-m-c-a',
  '/article/insurance/car-insurance-m-c-a-sw',
  '/article/insurance/car-insurance-rates-age-gender',
  '/article/insurance/car-insurance-young-drivers',
  '/article/insurance/cheap-full-coverage-insurance',
  '/article/insurance/cheapest-car-insurance',
  '/article/insurance/cheapest-car-insurance-in-alabama-al',
  '/article/insurance/cheapest-car-insurance-in-arizona-az',
  '/article/insurance/cheapest-car-insurance-in-colorado-co',
  '/article/insurance/cheapest-car-insurance-in-florida-fl',
  '/article/insurance/cheapest-car-insurance-in-georgia-ga',
  '/article/insurance/cheapest-car-insurance-in-illinois-il',
  '/article/insurance/cheapest-car-insurance-in-iowa-ia',
  '/article/insurance/cheapest-car-insurance-in-maryland-md',
  '/article/insurance/cheapest-car-insurance-in-massachusetts-ma',
  '/article/insurance/cheapest-car-insurance-in-michigan-mi',
  '/article/insurance/cheapest-car-insurance-in-missouri-mo',
  '/article/insurance/cheapest-car-insurance-in-new-jersey-nj',
  '/article/insurance/cheapest-car-insurance-in-new-york-ny',
  '/article/insurance/cheapest-car-insurance-in-north-carolina-nc',
  '/article/insurance/cheapest-car-insurance-in-ohio-oh',
  '/article/insurance/cheapest-car-insurance-in-pennsylvania-pa',
  '/article/insurance/cheapest-car-insurance-in-texas-tx',
  '/article/insurance/cheapest-car-insurance-in-virginia-va',
  '/article/insurance/cheapest-car-insurance-teenagers',
  '/article/insurance/full-coverage-insurance',
  '/article/insurance/how-much-is-car-insurance',
  '/article/insurance/how-to-buy-car-insurance',
  '/article/insurance/insurance-brokers',
  '/article/insurance/insurance-calculators',
  '/article/insurance/largest-auto-insurance-companies',
  '/article/insurance/minimum-car-insurance-requirements',
  '/article/insurance/non-owner-car-insurance-where-to-buy-and-what-it-covers',
  '/article/insurance/rental-car-insurance',
  '/article/insurance/salvage-title',
  '/article/insurance/save-money-car-insurance',
  '/article/insurance/seniors-auto-insurance',
  '/article/insurance/tesla-insurance',
  '/best/insurance/car-insurance-companies',
  '/blog/insurance/find-homeowners-insurance/',
  '/home-insurance/match',
  '/home-insurance/match/results',
  '/home/register',
  '/home/signin',
  '/home/signout',
  '/home/unsubscribe',
  '/insurance/auto/ca/los-angeles',
  '/insurance/auto/ca/san-diego',
  '/insurance/auto/fl/tampa',
  '/insurance/auto/il/chicago',
  '/insurance/auto/nv/las-vegas',
  '/insurance/auto/ny/new-york-city',
  '/insurance/auto/ok/oklahoma-city',
  '/insurance/auto/tx/houston',
  '/insurance/auto/tx/san-antonio',
  '/insurance/match',
  '/insurance/match/results',
  '/l/auto-insurance-1',
  '/l/auto-insurance-2',
  '/l/auto-insurance-3',
  '/l/auto-insurance-4',
  '/l/auto-insurance-5',
  '/l/auto-insurance-6',
  '/l/banking-best-cd-rates-cross-sell-savings-fa',
  '/l/banking-best-cd-rates-cross-sell-savings-fa-3',
  '/l/banking-best-cd-rates-cross-sell-savings-fa-4',
  '/l/investing-best-robo-cs-fa',
  '/m/banking/standout-money-market-accounts',
  '/m/banking/standout-money-market-accounts-2',
  '/m/banking/standout-online-checking-accounts-2',
  '/m/banking/standout-online-checking-accounts-2',
  '/m/banking/standout-online-checking-accounts-cs',
  '/m/banking/standout-online-savings-accounts-2',
  '/m/banking/standout-online-savings-accounts-4',
  '/m/banking/standout-online-savings-accounts-5',
  '/m/banking/standout-online-savings-accounts-6',
  '/m/banking/standout-online-savings-accounts-7',
  '/m/banking/standout-online-savings-accounts-8',
  '/m/banking/standout-online-savings-accounts-9',
  '/m/credit-cards-you-should-not-ignore-if-you-have-excellent-credit',
  '/m/credit-cards/excellent-airline-credit-cards',
  '/m/credit-cards/excellent-balance-transfer-credit-cards-2',
  '/m/credit-cards/excellent-cash-back-credit-cards',
  '/m/credit-cards/excellent-cash-back-credit-cards-2',
  '/m/credit-cards/excellent-credit-card-bonuses',
  '/m/credit-cards/excellent-credit-cards',
  '/m/credit-cards/excellent-credit-cards-2',
  '/m/credit-cards/excellent-credit-cards-d1',
  '/m/credit-cards/excellent-credit-cards-m1',
  '/m/credit-cards/excellent-low-interest-credit-cards',
  '/m/credit-cards/excellent-low-interest-credit-cards-2',
  '/m/credit-cards/excellent-no-annual-fee-credit-cards',
  '/m/credit-cards/excellent-rewards-credit-cards',
  '/m/credit-cards/excellent-rewards-credit-cards-2',
  '/m/credit-cards/excellent-secured-credit-cards',
  '/m/credit-cards/excellent-student-credit-cards',
  '/m/credit-cards/excellent-travel-credit-cards',
  '/m/credit-cards/excellent-travel-credit-cards-2',
  '/m/credit-cards/make-all-the-right-money-moves',
  '/m/credit-cards/make-all-the-right-money-moves-2',
  '/m/credit-cards/pay-0-intro-interest',
  '/m/credit-cards/pay-0-intro-interest-2',
  '/m/excellent-no-foreign-transaction-fee-credit-cards',
  '/m/insurance/compare-excellent-car-insurance-rates-for-you-b',
  '/m/insurance/compare-excellent-car-insurance-rates-for-you-m',
  '/m/insurance/life/compare-life-insurance',
  '/m/investing/how-to-buy-stocks-cs',
  '/m/investing/standout-online-brokers-cs-2',
  '/m/mortgages/best-mortgage-lenders',
  '/m/mortgages/best-mortgage-lenders-2',
  '/m/mortgages/compare-mortgage-lenders-2',
  '/m/mortgages/compare-top-mortgage-lenders',
  '/m/mortgages/compare-top-mortgage-lenders-2',
  '/m/mortgages/compare-top-mortgage-lenders-3',
  '/m/mortgages/compare-top-mortgage-lenders-4',
  '/m/mortgages/compare-top-mortgage-lenders-5',
  '/m/mortgages/compare-top-mortgage-lenders-pre-qual_pre-approval-desktop-2',
  '/m/mortgages/compare-top-mortgage-lenders-pre-qual_pre-approval-mobile-2',
  '/m/mortgages/compare-top-mortgage-lenders-rate_purchase-desktop-2',
  '/m/mortgages/compare-top-mortgage-lenders-rate_purchase-mobile-2',
  '/m/mortgages/compare-top-mortgage-lenders-rate_refinance-desktop-2?loanPurpose=refinance',
  '/m/mortgages/heloc-lenders-2',
  '/mortgages/best-mortgage-lenders',
  '/mortgages/home-loans',
  '/mortgages/mortgage-prequalification',
  '/reviews/insurance/aarp-the-hartford',
  '/reviews/insurance/allstate',
  '/reviews/insurance/american-family',
  '/reviews/insurance/american-national',
  '/reviews/insurance/auto-owners',
  '/reviews/insurance/direct-auto',
  '/reviews/insurance/elephant',
  '/reviews/insurance/erie',
  '/reviews/insurance/geico',
  '/reviews/insurance/good2go',
  '/reviews/insurance/liberty-mutual',
  '/reviews/insurance/njm',
  '/reviews/insurance/progressive',
  '/reviews/insurance/root',
  '/reviews/insurance/safeco',
  '/reviews/insurance/state-farm',
  '/reviews/insurance/travelers',
  '/reviews/insurance/usaa',
];
export const URLS_TO_SKIP_ON_DESKTOP: Array<string> = [
  '/m/banking/standout-online-savings-accounts-4',
];
export const URLS_TO_SKIP_ON_MOBILE: Array<string> = [
  '/article/insurance/car-insurance-m-c-b',
  '/article/insurance/car-insurance-quotes-m',
  '/article/insurance/pay-per-mile-car-insurance',
  '/article/insurance/types-of-life-insurance',
  '/m/banking/standout-online-savings-accounts-6',
  '/reviews/insurance/amica',
  '/reviews/insurance/farmers',
  '/reviews/insurance/metromile',
  '/reviews/insurance/the-general',
];
/** END: Global Registration Modal Exclusions */

/** BEGIN: Experiment Specific Registration Modal Exclusions */
export const CONTEXTUAL_VERTICALS_TO_INCLUDE: Array<string> = ['Credit Cards'];
export const CONTEXTUAL_CONTENT_TYPES_TO_INCLUDE: Array<string> = [
  'roundup',
  'article',
];

/** END: Experiment Specific Registration Modal Exclusions */

/** BEGIN: Registration Success/Error Modal contants */

export enum RegStatusSuccessVariants {
  CHECK_INBOX = 'check-inbox',
  SUCCESS = 'success',
}

export enum RegStatusErrorVariants {
  PROVIDER_ID_CONFLICT = 'provider_id_conflict',
  USER_MUST_SET_PASSWORD = 'user_must_set_password',
  OTHER = 'other',
}

export const REG_STATUS_SUCCESS_COPY: Record<
  RegStatusSuccessVariants,
  Record<string, string>
> = {
  'check-inbox': {
    desktopTextTitle: 'Check your inbox',
    desktopText:
      'Instructions for connecting your credit score are coming your way.',
  },

  success: {
    desktopText: 'Success! Thanks for signing up.',
    mobileTextTitle: 'Success!',
    mobileText: 'Thanks for signing up.',
    ctaText: 'Dismiss',
  },
};

export const REG_STATUS_ERROR_COPY: Record<
  RegStatusErrorVariants,
  Record<string, string>
> = {
  provider_id_conflict: {
    primaryCtaText: 'Sign in',
  },
  user_must_set_password: {
    title: 'Please sign in like you usually do.',
    content:
      "Looks like you have an account, but usually sign in a different way. Please sign in like you usually do.\n\nThen you can go to your NerdWallet settings and create a password — which you'll need if you want to sign in differently later.",
    primaryCtaText: 'Try again',
  },
  other: {
    title:
      'Something went wrong. Please try registering another way or contact our support team for help.',
    primaryCtaText: 'Try again',
    secondaryCtaText: 'Contact us',
  },
};
/** END: Registration Success/Error Modal contants */

export const CONTACT_US_URL =
  'https://support.nerdwallet.com/hc/en-us/requests/new/';

export const NW_DASHBOARD = '/home/dashboard/home';

export const REDIRECT_TO_HOME_TAXES_URLS = [
  '/article/taxes/4-good-ways-put-tax-refund-work',
  '/article/taxes/use-your-tax-return-to-map-out-a-better-financial-future',
  '/article/taxes/its-time-to-fix-social-securitys-tax-burden',
  '/article/taxes/moving-to-escape-taxes-make-sure-its-a-clean-break',
  '/article/finance/tax-traps-that-side-hustlers-should-avoid',
  '/article/taxes/tax-filing',
  '/article/taxes/irs-data',
  '/article/taxes/tax-deductions-tax-breaks',
  '/article/taxes/10-tax-forms-to-know-before-file',
  '/article/taxes/unemployment-taxable',
  '/article/taxes/jackson-hewitt-tax-debt-resolution-services-review',
  '/article/taxes/community-tax-review',
  '/article/taxes/irs-scaled-back-functions-coronavirus-how-you-can-adjust',
  '/article/taxes/optima-tax-relief-review',
  '/article/taxes/estate-tax',
  '/article/taxes/avoid-irs-scams',
  '/article/taxes/fsa-hsa-taxes',
  '/article/taxes/qualify-child-child-care-tax-credit',
  '/article/taxes/tax-relief-back-taxes',
  '/article/taxes/amended-tax-return',
  '/article/taxes/11-big-tax-mistakes-avoid',
  '/article/taxes/state-income-tax-rates',
  '/article/taxes/irs-phone-number-list-customer-service',
  '/article/taxes/can-you-take-earned-income-tax-credit',
  '/article/taxes/selling-home-capital-gains-tax',
  '/article/taxes/gift-tax-rate',
  '/article/taxes/1099-misc-form',
  '/article/taxes/tax-lien',
  '/article/taxes/tax-levy',
  '/article/taxes/get-irs-transcript-tax-transcript',
  '/article/taxes/reasons-irs-audit',
  '/article/taxes/how-to-set-up-irs-payment-plan',
  '/article/loans/personal-loans/tax-refund-loans-give-cash-now-to-early-filers',
  '/article/taxes/foreign-tax-credit-taxes-foreign-income',
  '/article/taxes/tax-deadline-tax-day-taxes-due',
  '/article/taxes/smart-ways-to-spend-your-tax-return',
  '/article/taxes/innocent-spouse-relief',
  '/article/taxes/investment-taxes-basics-investors',
  '/article/loans/student-loans/education-tax-credits',
  '/article/taxes/itemized-deductions-standard-deduction',
  '/article/taxes/what-is-w-2-form',
  '/article/taxes/tax-planning',
  '/article/taxes/alternative-minimum-tax-amt',
  '/article/taxes/claim-tax-dependent-rules-qualify',
  '/article/taxes/sales-tax-holiday-back-to-school-shopping',
  '/article/taxes/donor-advised-funds',
  '/article/taxes/federal-income-tax-brackets',
  '/article/taxes/capital-gains-tax-rates',
  '/article/taxes/california-state-tax',
  '/article/taxes/vat-value-added-tax',
  '/article/taxes/property-tax',
  '/article/taxes/irs-free-file-tax-preparation-help',
  '/article/investing/how-much-to-contribute-to-401k',
  '/article/taxes/taxes-on-stocks',
  '/article/taxes/standard-deduction',
  '/article/taxes/self-employment-tax',
  '/article/taxes/inheritance-tax',
  '/article/taxes/tax-deductible-donations-charity',
  '/article/taxes/401k-taxes',
  '/article/taxes/adjusted-gross-income-agi',
  '/article/taxes/form-1040',
  '/article/taxes/property-tax-deduction',
  '/article/taxes/dividend-tax-rate',
  '/article/taxes/schedule-c-definition',
  '/article/taxes/havent-received-w2-take-steps',
  '/article/taxes/tips-save-taxes',
  '/article/taxes/medical-expense-tax-deduction',
  '/article/taxes/sales-tax-deduction',
  '/article/taxes/pay-taxes-game-show-winnings',
  '/article/taxes/what-are-tax-exemptions-and-how-do-they-work',
  '/article/taxes/tax-credit-vs-tax-deduction',
  '/article/taxes/do-i-need-to-file-a-tax-return',
  '/article/taxes/tax-changes',
  '/article/taxes/how-to-find-best-tax-preparer-near',
  '/article/taxes/irs-extends-tax-filing-deadline-to-july-15',
  '/article/taxes/tax-prep-checklist',
  '/article/taxes/schedule-a',
  '/article/taxes/can-you-take-the-savers-credit',
  '/article/taxes/how-to-get-tax-extension-online',
  '/article/taxes/1099-int-form',
  '/article/taxes/dont-miss-tax-extension-deadline',
  '/article/taxes/what-tax-credits-can-i-qualify-for',
  '/article/taxes/taxes-on-mutual-funds',
  '/article/taxes/tax-deductions-credits-in-retirement',
  '/article/taxes/tax-evasion-vs-tax-avoidance',
  '/article/taxes/homeowner-tax-tips',
  '/article/taxes/tax-loss-harvesting',
  '/article/taxes/pay-irs-options',
  '/article/taxes/penalty-for-failure-to-file-taxes',
  '/article/taxes/tax-refund-late-irs-owe-interest',
  '/article/taxes/tax-breaks-for-parents-of-functional-needs-kids',
  '/article/taxes/havent-filed-tax-return-lately-you-can-still-get-refund',
  '/article/taxes/are-tips-taxable',
  '/article/taxes/fastest-tax-refund',
  '/article/taxes/form-1099-div',
  '/article/taxes/6-late-filing-tax-mistakes-need-avoid',
  '/article/taxes/tax-free-income-nontaxable-income',
  '/article/taxes/tax-breaks-caring-for-elderly-parents',
  '/article/taxes/how-long-to-keep-tax-records',
  '/article/taxes/best-time-file-tax-return',
  '/article/taxes/wealth-tax',
  '/article/taxes/tax-refund-stolen',
  '/article/taxes/medical-expenses-marijuana',
  '/article/taxes/cant-pay-income-taxes',
  '/article/taxes/how-irs-knows-if-you-cheat-on-taxes',
  '/article/taxes/irs-penalty-first-time-abatement',
  '/article/taxes/missing-tax-documents',
  '/article/taxes/file-taxes-jointly-separately-return',
  '/article/taxes/withdrawing-from-529-plan-college',
  '/article/taxes/what-happens-if-you-dont-pay-your-taxes-by-deadline',
  '/article/taxes/tax-deadline-postponed-90-days-coronavirus',
  '/article/taxes/filing-taxes-after-divorce',
  '/article/taxes/big-refund-give-yourself-a-raise',
  '/article/taxes/youre-filing-tax-return-late',
  '/article/taxes/need-a-tax-extension-you-might-already-have-one',
  '/article/taxes/harry-meghan-royal-family-welcome-bundle-tax-hassles',
  '/article/taxes/tips-to-cut-cost-of-having-taxes-done',
  '/article/taxes/take-the-headache-out-of-itemizing-your-tax-return',
  '/article/taxes/can-you-get-a-passport-if-you-owe-taxes',
  '/article/taxes/rental-owners-extra-tax-break',
  '/article/taxes/millennials-fear-filing-taxes',
  '/article/taxes/bad-day-tax-break',
  '/article/taxes/tax-breaks-new-college-graduates',
  '/article/taxes/split-tax-refund',
  '/article/taxes/find-good-tax-preparer',
  '/article/taxes/head-of-household-status',
  '/article/taxes/tax-preparer-mistake-on-your-return',
  '/article/taxes/dont-trust-spouse-at-tax-time',
  '/article/taxes/what-to-do-if-irs-breaks-rules',
  '/article/taxes/how-to-choose-tax-filing-status',
  '/article/investing/roth-ira-taxes',
  '/article/taxes/want-a-raise-in-2021-you-may-not-even-need-to-ask-for-it',
  '/article/taxes/irs-offer-in-compromise-basics-and-who-qualifies',
  '/article/taxes/turbotax-review',
  '/article/taxes/hr-block-review',
  '/article/taxes/taxact-review',
  '/article/taxes/taxslayer-review',
  '/article/taxes/track-my-refund',
  '/article/taxes/taxact-vs-turbotax',
  '/article/taxes/hr-block-vs-turbotax',
  '/article/taxes/best-tax-software',
  '/article/taxes/new-york-state-tax',
  '/article/taxes/5-ways-to-trim-your-tax-prep-costs-this-year',
  '/article/taxes/ip-pin',
  '/article/taxes/3-ways-to-get-socially-distanced-tax-prep-this-year',
  '/article/credit-cards/unwelcome-tax-surprises-may-await-those-with-debt',
  '/article/taxes/5-sneaky-things-covid-19-might-do-to-your-tax-bill',
  '/article/taxes/options-pay-tax-bill',
  '/article/taxes/tax-attorney',
  '/article/taxes/income-taxes/tax-refund-prepaid-debit-card',
  '/article/taxes/americans-dont-know-much-about-taxes-or-that-they-might-get-them-done-for-free',
  '/article/taxes/americans-missing-out-on-free-tax-software-dont-know-basic-irs-facts',
  '/article/taxes/taxes-in-retirement',
  '/article/taxes/virginia-state-tax',
  '/article/taxes/arizona-state-income-tax-rates',
  '/article/taxes/cant-pay-tax-bill',
  '/article/taxes/withholding-tax',
  '/article/taxes/rental-property-tax-deductions',
  '/article/taxes/529-tax-deduction-k-12-school',
  '/article/taxes/why-we-no-longer-fear-april-15',
  '/article/taxes/states-with-no-income-tax',
  '/article/taxes/irs-id-me-facial-recognition-scan',
  '/article/taxes/2021-tax-surprises',
  '/article/taxes/energy-tax-credits',
  '/article/taxes/data-taxpayers-freefile',
  '/article/taxes/bonus-tax-rate-how-are-bonuses-taxed',
  '/article/taxes/gas-taxes',
  '/article/taxes/ev-tax-credit-electric-vehicle-tax-credit',
  '/article/investing/social-security/do-self-employed-workers-pay-social-security-taxes',
  '/article/taxes/income-taxes/inflation-impact-taxes',
  '/article/taxes/year-end-tax-strategies',
  '/article/taxes/mortgage-interest-rate-deduction',
  '/article/taxes/nerdwallet-2023-tax-report',
  '/article/taxes/wheres-my-amended-tax-return',
  '/article/taxes/data-taxpayers-freefile-2023',
  '/article/taxes/w-9',
  '/article/taxes/nerdwallet-tax-report-2022',
  '/article/taxes/child-and-dependent-care-tax-credit',
  '/article/taxes/section-179-deduction',
  '/article/taxes/dont-miss-these-3-tax-credits-when-you-file-this-year',
  '/article/taxes/sports-betting-taxes',
  '/article/taxes/venmo-taxes',
  '/article/taxes/are-gofundme-donations-taxable-tax-tips-for-crowdfunding',
  '/article/taxes/solar-tax-credit',
  '/article/taxes/zelle-taxes',
  '/article/taxes/georgia-state-tax',
  '/article/taxes/salt-tax-deduction',
  '/article/taxes/ohio-state-tax',
  '/article/taxes/florida-taxes',
  '/article/taxes/illinois-tax',
  '/article/taxes/colorado-state-income-tax-rates',
  '/article/taxes/back-taxes-past-due-returns',
  '/article/taxes/free-tax-filing-how-to-file-taxes-for-free',
  '/article/taxes/form-4868-tax-extension-form',
  '/article/taxes/massachusetts-state-tax-rates',
  '/article/taxes/cpa-near-me',
  '/article/taxes/certified-public-accountant-what-is-a-cpa',
  '/article/taxes/lottery-tax-calculator',
  '/article/taxes/1099-b-form',
  '/taxes/tax-calculator',
  // Test URLs for dev and stage
  '/api/compass/dev',
  '/article/taxes/test-taxes-article',
];
